import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { ConfirmDialogComponent } from './confirm-dialog.component';
import { ConfirmDialogService } from './confirm-dialog.service';

@NgModule({
  declarations: [ConfirmDialogComponent],
  imports: [CommonModule, MatDialogModule, MatIconModule, MatButtonModule],
  providers: [ConfirmDialogService],
  exports: [ConfirmDialogComponent],
})
export class ConfirmDialogModule {
  static injector: Injector | null = null;
  constructor(public injector: Injector) {
    ConfirmDialogModule.injector = injector;
  }
}
